import React from 'react';
import { Trash2, Plus } from 'lucide-react';

// Estilos compartilhados (mesmos do ModalEditarFicha) — exportados para reuso
// pelas abas de cadastros enriquecidos.
export const inputCls =
  'w-full px-3 py-2 rounded-lg border border-gray-200 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-purple-400 disabled:bg-gray-50 disabled:text-gray-400';
export const labelCls = 'text-[10px] text-gray-400 uppercase tracking-wider font-semibold mb-1 block';

interface ListaEditavelProps<T> {
  itens: T[];
  onChange: (itens: T[]) => void;
  novoItem: () => T;
  rotuloAdd?: string;
  vazioMsg?: string;
  podeEditar?: boolean;
  renderLinha: (item: T, atualizar: (patch: Partial<T>) => void, index: number) => React.ReactNode;
}

function ListaEditavel<T>({
  itens,
  onChange,
  novoItem,
  rotuloAdd = '+ adicionar',
  vazioMsg = 'Nenhum item cadastrado.',
  podeEditar = true,
  renderLinha,
}: ListaEditavelProps<T>) {
  const atualizar = (index: number, patch: Partial<T>) => {
    onChange(itens.map((it, i) => (i === index ? { ...it, ...patch } : it)));
  };
  const remover = (index: number) => {
    onChange(itens.filter((_, i) => i !== index));
  };
  const adicionar = () => {
    onChange([...itens, novoItem()]);
  };

  return (
    <div className="space-y-3">
      {itens.length === 0 && (
        <p className="text-sm text-gray-400 italic">{vazioMsg}</p>
      )}
      {itens.map((item, i) => (
        <div
          key={i}
          className="flex items-start gap-2 p-3 rounded-xl border border-gray-100 bg-gray-50/50"
        >
          <div className="flex-1 min-w-0">
            {renderLinha(item, (patch) => atualizar(i, patch), i)}
          </div>
          {podeEditar && (
            <button
              type="button"
              onClick={() => remover(i)}
              title="Remover"
              className="p-2 rounded-lg text-gray-400 hover:bg-rose-50 hover:text-rose-600 transition flex-shrink-0"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          )}
        </div>
      ))}
      {podeEditar && (
        <button
          type="button"
          onClick={adicionar}
          className="inline-flex items-center gap-1 text-sm text-purple-600 hover:underline"
        >
          <Plus className="w-3.5 h-3.5" /> {rotuloAdd.replace(/^\+\s*/, '')}
        </button>
      )}
    </div>
  );
}

export default ListaEditavel;
